import { Modal, ModalProps, Stack, Text } from "@mantine/core"

import { Button, EqualWidthGrid } from "@tfg/ui"

type AreYouSureModalProps = {
  opened: boolean
  onClose: () => void
  onConfirm: () => void
  onCancel?: () => void
  areYouSureText: string
  confirmText?: string
  cancelText?: string
  title?: string
} & ModalProps

export const AreYouSureModal = ({
  opened,
  onClose,
  onConfirm,
  onCancel,
  areYouSureText,
  confirmText = "Confirm",
  cancelText = "Cancel",
  title = "Confirm Action",
}: AreYouSureModalProps) => {
  const handleConfirm = () => {
    onConfirm()
    onClose()
  }

  const handleCancel = () => {
    onCancel?.()
    onClose()
  }

  return (
    <Modal opened={opened} onClose={onClose} title={title} centered>
      <Stack>
        <Text>{areYouSureText}</Text>
        <EqualWidthGrid>
          <Button fullWidth variant="secondary" onClick={handleCancel}>
            {cancelText}
          </Button>
          <Button fullWidth variant="primary" onClick={handleConfirm}>
            {confirmText}
          </Button>
        </EqualWidthGrid>
      </Stack>
    </Modal>
  )
}
